import { render, staticRenderFns } from "./VehiclesCross.vue?vue&type=template&id=c8b01714&scoped=true"
import script from "./VehiclesCross.vue?vue&type=script&lang=js"
export * from "./VehiclesCross.vue?vue&type=script&lang=js"
import style0 from "./VehiclesCross.vue?vue&type=style&index=0&id=c8b01714&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b01714",
  null
  
)

export default component.exports